import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var CouponNotice = React.createClass({

	getInitialState() {
		return {store: AvailabilityStore.getState()};
	},

	componentDidMount() {
		AvailabilityStore.listen(this.onChange);
	},

	componentWillUnmount() {
		AvailabilityStore.unlisten(this.onChange);
	},

	onChange(state) {
		this.setState({store: state});
	},

	render() {
		const { t } = this.props;

		var store = this.state.store;

		
		if(!store.getIn(['coupon', 'code'])) {
			return false;
		}

		return (
			<div className="well"><h3 className="txt_eligible">{store.getIn(['coupon', 'txt_prequal']) || t('coupon_txt_prequal')}</h3></div>
		);
	}
});

export default  translate('common', { wait: true })(CouponNotice);
